import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// A user's display name. WapStat is an English app, so always use the English
// `name` (the Dhivehi nameDv is ignored here).
export function displayName(u: { name: string; nameDv?: string | null }): string {
  return u.name;
}

const ZONE_ROLE_LABEL = { COUNCILLOR: 'Councillor', SECRETARY_GENERAL: 'Secretary General', STAFF: 'Staff' } as const;
/** Label for a user's role line: census role, else zone role, else an em dash. */
export function roleLabel(role: string | null | undefined, zoneRole: keyof typeof ZONE_ROLE_LABEL | null | undefined, census: Record<string, string>): string {
  if (role) return census[role] ?? role;
  return zoneRole ? ZONE_ROLE_LABEL[zoneRole] : '—';
}
